import React, { useContext, useState, useEffect } from "react";
import { DisplayDiscussionForMiniScreenProvider } from "../contexts/DisplayDiscussionForMiniScreenContext";
import Navbar from "../components/Navbar";
import ContentFormSquelette from "../layouts/ContentFormSquelette";
import ProgessStep from "../components/ProgressStep";
import Form from "../components/Form";
import { useNavigate } from "react-router-dom";
import InputText from "../components/InputText";
import { FaThumbsUp } from "react-icons/fa";
import { FaArrowRightLong, FaArrowLeftLong } from "react-icons/fa6";
import { AuthContext } from "../contexts/AuthContext";
import { createGroupe, createGroupeWithImage } from "../services/groupes";
import CheckboxList from "../components/CheckboxList";
import { getUsers } from "../services/comptes-users";
import InputFile from "../components/InputFile";
import Spinner from "../components/Spinner";

export default function NouveauPage() {
  const { user } = useContext(AuthContext);
  const [value, setValue] = useState("");
  const [nomGroupe, setNomGroupe] = useState("");
  const [users, setUsers] = useState([]);
  const [visibility, setVisibility] = useState(null);
  const [imageGroupe, setImageGroupe] = useState(null);
  const [membersOfGroup, setMembersOfGroup] = useState([
    { userId: user.userId },
  ]);
  const [displayError, setDisplayError] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (users.length === 0) {
      getUsers({}, setUsers);
    }
  }, [users]);

  useEffect(() => {
    if (visibility === false) {
      navigate("/groupes");
    }
  }, [visibility]);

  const nextStep = (currentStep) => {
    setActiveStep((lastStep) => {
      if (lastStep === currentStep - 1) {
        return lastStep + 1;
      } else {
        return lastStep - 1;
      }
    });
  };

  return (
    <>
      <DisplayDiscussionForMiniScreenProvider>
        <Navbar />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "7rem",
          }}
        >
          <ProgessStep idx={activeStep} />
        </div>
        <ContentFormSquelette
          style={{
            marginTop:
              activeStep === 0 ? "-100px" : activeStep === 1 ? 0 : "-100px",
          }}
        >
          <form>
            <Form
              faire={`${
                activeStep === 0
                  ? "Création d'un groupe"
                  : activeStep === 1
                  ? "Choisir les membres"
                  : "Choisissez l'image du groupe (Facultative)"
              }  `}
              colClasses="col-xl-4 col-lg-5 col-md-7 col-sm-9 animate__animated animate__fadeInUp"
            >
              {activeStep === 0 ? (
                <div className="row g-3">
                  <InputText
                    label="Nom du groupe"
                    placeholder="Saisissez le nom du groupe"
                    value={value}
                    onChange={(evt) => setValue(evt.target.value)}
                    col="col-12"
                  />
                  <div className="col-12">
                    <button
                      className="btn btn-primary w-100"
                      disabled={
                        value.length > 2 && value.trim() !== "" ? false : true
                      }
                      onClick={(evt) => {
                        evt.preventDefault();
                        if (value.length > 2 && value.trim() !== "") {
                          setNomGroupe(value);
                          nextStep(1);
                          createGroupe(0, value);
                          setValue("");
                        } else {
                          setMessageError(
                            "Veuillez saisir un nom de groupe conforme"
                          );
                          setDisplayError(true);
                          setTimeout(() => {
                            setDisplayError(false);
                          }, 5000 * 2);
                        }
                      }}
                    >
                      Suivant <FaArrowRightLong />
                    </button>
                  </div>
                  {displayError ? (
                    <small className="text-danger">{messageError}</small>
                  ) : (
                    <></>
                  )}
                </div>
              ) : activeStep === 1 ? (
                <div className="row g-3">
                  <CheckboxList
                    users={users}
                    membersOfGroup={membersOfGroup}
                    setMembersOfGroup={setMembersOfGroup}
                  />
                  <div className="col-12">
                    <button
                      className="btn btn-warning w-100"
                      onClick={(evt) => {
                        evt.preventDefault();
                        nextStep(0);
                      }}
                    >
                      <FaArrowLeftLong /> Précédent
                    </button>
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-primary w-100"
                      disabled={membersOfGroup.length > 1 ? false : true}
                      onClick={(evt) => {
                        evt.preventDefault();
                        if (membersOfGroup.length > 1) {
                          nextStep(2);
                          createGroupe(1, membersOfGroup);
                        } else {
                          alert("Choisissez les membres");
                          setTimeout(() => {
                            setDisplayError(false);
                          }, 5000);
                        }
                      }}
                    >
                      Suivant <FaArrowRightLong />
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="row g-3">
                    {visibility === true ? (
                      <Spinner visibility={visibility} />
                    ) : (
                      <>
                        <InputFile
                          setImageGroupe={setImageGroupe}
                          imageGroupe={imageGroupe}
                        />
                        {activeStep > 0 ? (
                          <div className="col-12">
                            <button
                              className="btn btn-warning w-100"
                              onClick={(evt) => {
                                evt.preventDefault();
                                nextStep(activeStep);
                              }}
                            >
                              <FaArrowLeftLong /> Précédent
                            </button>
                          </div>
                        ) : (
                          <></>
                        )}
                        <div className="col-12">
                          <button
                            className="btn btn-primary w-100"
                            onClick={(evt) => {
                              evt.preventDefault();
                              setVisibility(true);
                              createGroupeWithImage(
                                2,
                                {
                                  imageGroupe,
                                  membres: membersOfGroup,
                                  nomGroupe: nomGroupe || value,
                                },
                                setVisibility
                              );
                            }}
                          >
                            Terminé <FaThumbsUp />
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </Form>
          </form>
        </ContentFormSquelette>
      </DisplayDiscussionForMiniScreenProvider>
    </>
  );
}
